import createHistory from "history/createBrowserHistory";
import { routerMiddleware } from "react-router-redux";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";
import createSagaMiddleware from "redux-saga";
import { all } from "redux-saga/effects";
import { saveStore } from "../api/utils";
import { adUnitBuilderReducer, adUnitBuilderSaga, AdUnitBuilderState } from "./adunit-builder";
import { authSaga } from "./auth";
import { campaignReducer, campaignSaga, CampaignState, downloadpdfSaga } from "./campaign";
import { campaignListReducer, CampaignListState, dashboardSaga } from "./campaignList";
import { clientReducer, clientSaga, ClientState } from "./client";
import { mappingsReducer, MappingState } from "./mappings";
import { modalReducer, ModalState } from "./modal";
import { pageReducer } from "./page/reducer";
import { pagesSaga } from "./page/saga";
import { PagesState } from "./page/state";
import { downloadSaga, reportSaga, reportsReducer, ReportState } from "./reports";
import { routeReducer, RouteState } from "./route";
import { signupSaga, signupReducer, SignupState } from "./signup";
import { usersPageSaga, UsersState, usersReducer } from "./users";
import { tourSaga, TourState, tourReducer } from "./tour";

export interface AppState {
    campaignList: CampaignListState;
    reports: ReportState;
    campaignState: CampaignState;
    pagesState: PagesState;
    clientState: ClientState;
    route: RouteState;
    modal: ModalState;
    mappings: MappingState;
    adUnitBuilder: AdUnitBuilderState;
    signupState: SignupState;
    usersState: UsersState;
    tours: TourState;
}

const composeEnhancers = (window as any)["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"] || compose;
const sagaMiddleware = createSagaMiddleware();
export const browserHistory = createHistory();

export const store = createStore(
    combineReducers<AppState>({
        campaignList: campaignListReducer,
        reports: reportsReducer,
        campaignState: campaignReducer,
        pagesState: pageReducer,
        route: routeReducer,
        modal: modalReducer,
        clientState: clientReducer,
        mappings: mappingsReducer,
        adUnitBuilder: adUnitBuilderReducer,
        signupState: signupReducer,
        usersState: usersReducer,
        tours: tourReducer
    }),
    composeEnhancers(applyMiddleware(sagaMiddleware, routerMiddleware(browserHistory)))
);

saveStore(store);

sagaMiddleware.run(function*() {
    yield all([
        authSaga(),
        pagesSaga(),
        campaignSaga(),
        dashboardSaga(a => store.dispatch(a)),
        reportSaga(),
        clientSaga(),
        downloadSaga(a => store.dispatch(a)),
        downloadpdfSaga(a => store.dispatch(a)),
        adUnitBuilderSaga(),
        signupSaga(),
        usersPageSaga(),
        tourSaga()
    ]);
});
